/** @jsxImportSource @emotion/react */
import React from "react";
import { colors } from "./colors";
import { css } from "@emotion/react";

interface IconButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  icon: React.ReactNode;
  type?: "button" | "submit" | "reset" | undefined;
}

const iconButtonStyle = css`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: 24px;
  height: 24px;
  max-width: 24px;
  max-height: 24px;
  align-items: center;
  justify-content: center;
  border-style: none;
  border-radius: 4px;
  background-color: ${colors.transparent};
  color: ${colors.textPrimary};
  &:hover {
    background-color: ${colors.greyBorder};
  }
`;

export const IconButton = ({
  icon,
  className,
  style,
  type,
  ...rest
}: IconButtonProps) => {
  return (
    <button css={iconButtonStyle} type={type ?? "button"} {...rest}>
      {icon}
    </button>
  );
};
